import { genericFetchingActionCreator } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'

export const fetchAssignmentNotes = (propertyAppraisalId, lin) => {
  return (dispatch) => {
    dispatch(genericFetchingActionCreator('ASSIGNMENT_NOTES', 'fetching'))
    fetch(`/lgyhub/api/appraiser-workspace/property-appraisal/${propertyAppraisalId}/notes`, {
      credentials: 'include',
      method: 'GET'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, `retrieving notes for case ${lin}`)
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        throw new Error(responseJson.errors[0].message)
      } else {
        let list = { list: responseJson }
        dispatch(genericFetchingActionCreator('ASSIGNMENT_NOTES', 'fetched', list))
      }
    }).catch((error) => {
      dispatch(genericFetchingActionCreator('ASSIGNMENT_NOTES', 'error'))
      console.error('Appraisal Notes fetching error: ', error)
    })
  }
}
